import { useState } from "react";
import { FlowChart } from "@client/shared/components";
import { noop, CHART_ELEM_TYPE } from "@client/shared/constants";
import Box from "@mui/material/Box";
import style from './style'
import Typography from "@mui/material/Typography";

const defaultState = {
	showStepModal: false,
	isAddingNewStep: false,
	editingStep: null, // Index of element that was clicked for edit.
	addingStepAfter: null, // Index of the element after which new element is being added.
};

export default function DeliveryFlowView({
	ACTIONS_TYPES = [],
	delivery = [], // This is the data that is saved on backend. This should not be an empty array in case of notification edit.
	onChange = noop, // Pass the data that can be sent directly to backend.
	onAddElement = noop,
	onElementClick = noop,
	onElementRemove = noop,
}) {
	const [state, setState] = useState(defaultState);

	function getChartData(saveData) {
		const chartData = [
			//{
			//elementType: CHART_ELEM_TYPE.START,
			//onClick: null,
			//disableRemove: true,
			//goto: 1,
			//},
		];
		saveData.forEach((element, index) => {
			const labelHeading = ACTIONS_TYPES.find(item => item.type === element.type)?.label || "-";
			const labelValue = element.value || '-';
			let label = `${labelHeading}: ${labelValue}`;

			if (element.type === 'goto') {
				const repeatElement = delivery.find(item => item?.id === +element.repeatGoto) || {}
				const repeatLabelHeading = ACTIONS_TYPES.find(item => item.type === repeatElement.type)?.label || "-";
				let repeatLabelValue = repeatElement.value || '-';
				if (repeatElement?.type === 'webhook') {
					repeatLabelValue = repeatElement?.value?.webhook || "-";
				}
				if (repeatElement?.type === 'ringout') {
					repeatLabelValue = repeatElement?.value?.extensionPhoneNumber?.phoneNumber || "-";
				}
				let repeatLabel = `${repeatLabelHeading}: ${repeatLabelValue}`;
				label = `${labelHeading}(${labelValue}): ${repeatLabel}`;
			}

			if (element.type === 'delay') {
				label += ` (${element.delayUnit === 'min' ? 'Minute(s)' : 'Second(s)'})`;
			}

			if (element.type === 'webhook') {
				label = `${labelHeading}: ${element.value?.webhook || "-"}`;
			}

			if (element.type === 'ringout') {
				label = `${labelHeading}: ${element.value?.extensionPhoneNumber?.phoneNumber || "-"}`;
			}

			chartData.push({
				...element,
				elementType:
					element.type === "voicemail-read-condition"
						? CHART_ELEM_TYPE.CONDITION
						: CHART_ELEM_TYPE.STEP,
				onClick: () => (element.goto === null ? noop : null),
				label
			});
		});
		return chartData;
	}


	// Move the inline styling of this div to style.js
	return (
		<>
			<Typography sx={{ my: 2 }} variant="body1">Please click on the arrow to add an element to the workflow.</Typography>
			<Box sx={style.flowWrapper}>
				<FlowChart
					elements={getChartData(delivery)}
					onElementRemove={onElementRemove}
					onElementClick={onElementClick}
					onAddElement={onAddElement}
				/>
			</Box>
		</>
	);
}
